import { Typography, Container } from '@mui/material'
import React from 'react'
import _ from 'lodash'

//components
import BottomButton from '../../common/BottomButton'
//styles
import './index.css'
//types
import { MessageLayoutProps } from 'types'
//utils
import { BackArrow } from 'utils/icons'

const MessageLayout = ({
  className = '',
  style,
  isLoading = false,
  title,
  children,
  button,
  imageSrc,
  handleBackArrowClick,
  showPlaybackLogo = true,
}: MessageLayoutProps) => {
  return (
    <>
      <div className={isLoading ? 'blured' : ''}>
        <Container maxWidth="sm" sx={{ position: 'relative' }}>
          {handleBackArrowClick && (
            <div className="messageLayoutBackArrow" onClick={handleBackArrowClick}>
              <BackArrow />
            </div>
          )}
          <div className={`messageLayoutContent ${className}`} style={style}>
            <img
              src="/images/playbackLogo.png"
              className="messageLayoutLogo"
              alt="Playback Rewards"
            />
            <div>
              {showPlaybackLogo && (
                <img
                  className="messageLayoutImage"
                  src={imageSrc || '/images/createAccountSliderImage2.png'}
                  alt=""
                />
              )}
              <Typography variant="h1">{title}</Typography>
              <div className="messageLayoutText">{children}</div>
            </div>
            <div className="messageLayoutButton">
              {!_.isEmpty(button) && (
                <BottomButton
                  handleClick={button.handleClick}
                  disabled={button.disabled}
                  style={{ marginBottom: '20px' }}
                >
                  {button.text}
                </BottomButton>
              )}
            </div>
          </div>
        </Container>
      </div>
    </>
  )
}

export default MessageLayout
